@if (formSubmission()) {
  <div class="flex justify-end my-2">
    <button
      type="button"
      pButton
      icon="pi pi-download"
      label="Download Referral"
      [downloadReferral]="data.referralId"
      [tenantId]="data.tenantId"
      [memberId]="data.memberId"
      [subscriberNumber]="data.subscriberNumber"
      [dateOfReferral]="data.dateOfReferral"
    ></button>
  </div>
} @else if (!isLoading()) {
  <div class="p-4">
    <p>Unable to load referral form. Please try again.</p>
  </div>
}
<mnc-formio
  lazyComponent
  class="f-io"
  [form]="formSubmission()?.form"
  [submission]="formSubmission()?.submission"
  [readOnly]="true"
></mnc-formio>
@if (formSubmission()) {
  <div class="flex justify-end my-2">
    <button
      type="button"
      pButton
      icon="pi pi-download"
      label="Download Referral"
      [downloadReferral]="data.referralId"
      [tenantId]="data.tenantId"
      [memberId]="data.memberId"
      [subscriberNumber]="data.subscriberNumber"
      [dateOfReferral]="data.dateOfReferral"
    ></button>
  </div>
}
